import { checkAuthentication } from "@credit-acceptance/common-frontend";

let isRedirecting = false;

/**
 * Handles 401 responses by delegating to checkAuthentication() from
 * common-frontend. That function validates the OAuth2 cookie via
 * /oauth2/auth and only redirects to /oauth2/start when the cookie is
 * actually invalid, which avoids CSRF token mismatches on the callback.
 */
export async function handle401Response(): Promise<void> {
  if (isRedirecting) return;

  isRedirecting = true;
  try {
    // TODO(OR-20985): before redirecting on an expired session, attempt a
    // best-effort releaseHeldVlaLock() so a lapsed session frees the deal lock.
    // Note the cookie is likely already invalid here, so the DELETE may 401 —
    // the server-side reaper (spec FR-7) remains the backstop. Deferred for now.
    const result = await checkAuthentication();

    // If checkAuthentication did not redirect (cookie was actually valid),
    // unlock the guard so future 401s can retry.
    if (!result.isRedirectingToLogin) {
      isRedirecting = false;
    }
  } catch {
    // Unlock on failure so subsequent 401s aren't permanently swallowed.
    isRedirecting = false;
  }
}

/**
 * Resets the in-module `isRedirecting` guard. Exported solely so unit
 * tests can isolate cases — the leading double underscore + `ForTests`
 * suffix signals "do not call from feature code." Calling this in
 * production defeats the dedup that prevents stacked redirects.
 */
export function __resetRedirectStateForTests(): void {
  isRedirecting = false;
}
